const ImgWithFallback = ({
  src,
  fallbackSrc,
  mediaType = "image/webp",
  alt,
  ...delegated
}) => {
  return (
    <picture>
      <source srcSet={src} type={mediaType} />
      <img src={fallbackSrc} alt={alt} {...delegated} />
    </picture>
  );
};

export { ImgWithFallback };
